import type { Component } from "react"

import { curryShouldUpdateWithManagedState as curryShouldUpdateWithManagedStateFn } from "./curry-should-update-with-managed-state"
import { curryUpdateManagedState as curryUpdateManagedStateFn } from "./curry-update-managed-state"
import { hasManagedState as hasManagedStateFn } from "./hasManagedState"
import { shouldUpdateWithSpecificProps as shouldUpdateWithSpecificPropsFn } from "./should-update-with-specific-props"

export namespace ReactPerformance {
  export type ComponentWithManagedState<
    Props,
    State extends ManagedState
  > = Component<Props, Managed<State>> & {
    setState: Component<Props, Managed<State>>[`setState`]
    updateState: ReactPerformance.Functions.UpdateState<State>
  }

  export type ManagedState = { update: boolean }

  export type Managed<State> = State & ManagedState

  export type Update<State> =
    | Partial<Omit<State, `update`>>
    | ((prevState: State) => Omit<State, `update`>)
    | UpdateSignal

  export type UpdateSignal = {
    update: true
  }

  export namespace Functions {
    export type ManageState<Props, State extends ManagedState> = (args: {
      nextProps: Props
      nextState: State
    }) => Update<State> | void

    export type ShouldComponentUpdate<Props, State> = (
      nextProps: Readonly<Props>,
      nextState: Readonly<State>
    ) => boolean

    export type UpdateState<State> = (
      changes: Update<State>,
      callback?: () => void
    ) => Promise<State>
  }

  export const curryShouldUpdateWithManagedState =
    curryShouldUpdateWithManagedStateFn

  export const curryUpdateManagedState = curryUpdateManagedStateFn

  export const hasManagedState = hasManagedStateFn

  export const shouldUpdateWithSpecificProps = shouldUpdateWithSpecificPropsFn
}
